
export class EditClientGroupsModel {
  public ClientId: number;
  public ClientGroupsIds: number[];
}
